import i18n from 'modules/core/lib/i18n'

import Item from 'modules/contracts/components/ContractDetails/LegalAndLabour/Item'

interface Props {
  mutuelle?: string
}

const Mutuelle = ({ mutuelle }: Props) => {
  return (
    <Item
      title={i18n.t('contract_versions.legal_and_labour.france.mutuelle')}
      description={mutuelle}
    />
  )
}

export default Mutuelle
